if ($('.alertClosable').length) {
    let closeText = '';

    if ($('.alertClosable').attr('data-close-text')) {
        closeText = $('.alertClosable').attr('data-close-text'); // For different text or languages
    } else {
        closeText = 'Close alert';
    }

    $('.alertClosable').append(
        $(document.createElement('button')).prop({
            type: 'button',
            innerHTML: '<span class="cross"></span><span class="visually-hidden">'+closeText+'</span>',
            class: 'alert-close alertClose'
        })
    );

    $('.alertClose').on( "click", function() {
        $('.alertClosable').fadeOut();
    });
}
